module.exports = __webpack_public_path__ + "static_pc/img/29.40feeea9.png";